import { createAction, props } from '@ngrx/store';

export const storeChatData = createAction(
  '[Chat API] Store Chat Data',
  props<{
    chat: {
      transactionId: string;
    };
  }>()
);

export const clearChatData = createAction(
  '[Chat API] Clear Chat Data'
);

export const setLoading = createAction(
  '[Chat] Set Loading',
  props<{ isLoading: boolean }>()
);

export const clearLoading = createAction(
  '[Chat] Clear Loading'
);